import { FC, useEffect, useState } from 'react';
import { useLoaderData, useParams } from 'react-router-dom';

import { ContentLoading } from '../../../../shared/components/loading/loading.component';
import { TabPanel } from '../../../../shared/components/tabs';
import { TabContentContainer } from '../../../../shared/components/tabs/tabsContainer.component.tsx';
import { TMode, modeService } from '../../../../shared/services/mode/mode.service';
import { ArticleTabs, ITabState } from '../../states/tabState.model';
import { articleTabLoadingService } from './articleTababLoading.service';
import { AvailabilityTab } from './availability/availability.tab';
import { CashAssistTab } from './cashassist/cashassist.tab';
import { LabelTab } from './label/label.tab.tsx';
import { ListsTab } from './lists/lists.tab';
import { PostTab } from './post/post.tab';
import { ProductionTab } from './production/production.tab';
import { DefaultOrderTab } from './defaultOrder/defaultOrder.tab.tsx';
import { isDoughService } from './articleIsDough.service.ts';
import { GeneralModeContainer } from './general/generalModeContainer.tsx';
import { Box } from '@mui/material';

const ArticleDetails: FC = () => {
  const { tab } = useParams() as { tab: ArticleTabs };
  const { isDough: initIsDough } = useLoaderData() as ITabState;

  const [loading, setLoading] = useState<boolean>(false);
  const [mode, setMode] = useState<TMode>('edit');
  const [isDough, setIsDough] = useState<boolean>(initIsDough);

  useEffect(() => {
    const unsubLoading = articleTabLoadingService.sub.loading().subscribe((v) => {
      setLoading(v.isLoading);
    });
    const unsubMode = modeService.sub.mode().subscribe(setMode);
    const unsubIsDough = isDoughService.sub.isDough().subscribe(setIsDough);
    return () => {
      modeService.pub.mode('edit');
      isDoughService.pub.clean();
      unsubMode.unsubscribe();
      unsubLoading.unsubscribe();
      unsubIsDough.unsubscribe();
    };
  }, []);

  return (
    <TabContentContainer>
      <Box sx={{ flexGrow: 1 }}>
        <ContentLoading loading={loading}>
          {tab === ArticleTabs.general && (
            <GeneralModeContainer mode={mode} tab={tab} isDough={isDough} />
          )}

          {mode === 'edit' && (
            <>
              <TabPanel value={ArticleTabs.lists} activeValue={tab}>
                <ListsTab />
              </TabPanel>
              <TabPanel value={ArticleTabs.availability} activeValue={tab}>
                <AvailabilityTab />
              </TabPanel>
              <TabPanel value={ArticleTabs.production} activeValue={tab}>
                <ProductionTab />
              </TabPanel>
              <TabPanel value={ArticleTabs.cashAssist} activeValue={tab}>
                <CashAssistTab />
              </TabPanel>
              <TabPanel value={ArticleTabs.post} activeValue={tab}>
                <PostTab />
              </TabPanel>
              <TabPanel value={ArticleTabs.label} activeValue={tab}>
                <LabelTab />
              </TabPanel>
              <TabPanel value={ArticleTabs.defaultOrder} activeValue={tab}>
                <DefaultOrderTab />
              </TabPanel>
            </>
          )}
        </ContentLoading>
      </Box>
    </TabContentContainer>
  );
};
export default ArticleDetails;
